/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { ReactElement } from "react";

import {
  CHANNEL_LOGOS,
  getMediaTagsByType,
  IMediaCategoryModel,
} from "@nf/common";
import { AppConfig, IS_CHILD_COOKIE } from "@nf/constants";
import { GetServerSideProps } from "next";
import dynamic from "next/dynamic";
import { NextSeo } from "next-seo";

import type {
  Channel,
  SearchScreenProps,
} from "screens/SearchScreen/SearchScreen";

const Layout = dynamic(() => import("layouts/Layout"));

const SearchScreen = dynamic(() => import("screens/SearchScreen"));

import styles from "screens/SearchScreen/SearchScreen.module.scss";

const CHANNELS: Channel[] = [
  {
    url: `/${AppConfig.ChannelHome}`,
    icon: CHANNEL_LOGOS[AppConfig.ChannelHome].labeled,
    ageRestricted: true,
  },
  {
    url: `/${AppConfig.ChannelDansk}`,
    icon: CHANNEL_LOGOS[AppConfig.ChannelDansk].labeled,
    ageRestricted: true,
  },
  {
    url: `/${AppConfig.ChannelKids}`,
    icon: CHANNEL_LOGOS[AppConfig.ChannelKids].labeled,
    ageRestricted: false,
  },
];

export const getServerSideProps: GetServerSideProps<SearchScreenProps> = async (
  ctx
) => {
  const { getCommonServerSideProps } = await import(
    "helpers/getCommonServerSideProps"
  );
  const { commonProps, DataProvider } = await getCommonServerSideProps(ctx);

  const cookies = ctx.req.cookies;
  const isChild = cookies?.[IS_CHILD_COOKIE] === "true";

  const mediaCategories = await DataProvider.getMediaCategories(true);
  let genreList: IMediaCategoryModel[] = [];

  if (mediaCategories) {
    genreList = getMediaTagsByType(mediaCategories.Entities);
  }

  return {
    props: {
      ...commonProps,
      enableRecommendations: !isChild,
      genreList,
      channels: CHANNELS.filter((channel) => {
        if (isChild && channel.ageRestricted) {
          return false;
        }
        return true;
      }),
    },
  };
};

const SearchScreenWrapper = (props: SearchScreenProps) => {
  return <SearchScreen {...props} />;
};

SearchScreenWrapper.getLayout = function getLayout(page: ReactElement) {
  const { props } = page;
  return (
    <Layout config={props?.config} className={styles.layout}>
      <NextSeo nofollow />
      {page}
    </Layout>
  );
};

export default SearchScreenWrapper;
